import noop from 'lodash/noop';
import { createActions } from 'redux-actions';

export const actions = createActions(
  {
    PERSONAL_SUBMIT_MESSAGE_WITH_ENTER: [
      (payload: any) => payload,
      (payload, resolve = noop, reject = noop) => ({ resolve, reject }),
    ],
    PERSONAL_BUSYLIGHT: [
      (payload: any) => payload,
      (payload, resolve = noop, reject = noop) => ({ resolve, reject }),
    ],
    PERSONAL_KEYBOARD_SHORTCUTS: [
      (payload: any) => payload,
      (payload, resolve = noop, reject = noop) => ({ resolve, reject }),
    ],
    PERSONAL_LEFT_MENU: [
      (payload: any) => payload,
      (payload, resolve = noop, reject = noop) => ({ resolve, reject }),
    ],
    PERSONAL_CUSTOM_CARD_MENU: [
      (payload: any) => payload,
      (payload, resolve = noop, reject = noop) => ({ resolve, reject }),
    ],
    PERSONAL_SOUND: [
      (payload: any) => payload,
      (payload, resolve = noop, reject = noop) => ({ resolve, reject }),
    ],
    PERSONAL_LAST_FROM_EMAIL_INTEGRATION: [
      (payload: any) => payload,
      (payload, resolve = noop, reject = noop) => ({ resolve, reject }),
    ],
    PERSONAL_CONVERSATION_CARDS: [
      (payload: any) => payload,
      (payload, resolve = noop, reject = noop) => ({ resolve, reject }),
    ],
    PERSONAL_REPLY_AREA_HEIGHT: [
      (payload: any) => payload,
      (payload, resolve = noop, reject = noop) => ({ resolve, reject }),
    ],
    PERSONAL_ADD_TO_FAVOURITE_TEAM_MEMBER_IDS: [
      (payload: any) => payload,
      (payload, resolve = noop, reject = noop) => ({ resolve, reject }),
    ],
    PERSONAL_REMOVE_FROM_FAVOURITE_TEAM_MEMBER_IDS: [
      (payload: any) => payload,
      (payload, resolve = noop, reject = noop) => ({ resolve, reject }),
    ],
    PERSONAL_TOGGLE_STRICT_SEARCH: [
      (payload: any) => payload,
      (payload, resolve = noop, reject = noop) => ({ resolve, reject }),
    ],
    PERSONAL_TOGGLE_REMEMBER_MICROPHONE_ACCESS: [
      (payload: any) => payload,
      (payload, resolve = noop, reject = noop) => ({ resolve, reject }),
    ],
    PERSONAL_TOGGLE_REMEMBER_ELEVIO_CARD_OPEN: [
      (payload: any) => payload,
      (payload, resolve = noop, reject = noop) => ({ resolve, reject }),
    ],
    PERSONAL_CHANGED_ELEVIO_SELECTED_LANGUAGE: [
      (payload: { selectedLanguageId: string }) => payload,
      (payload, resolve = noop, reject = noop) => ({ resolve, reject }),
    ],
    PERSONAL_TOGGLE_REMEMBER_KNOWLEDGE_CARD_OPEN: [
      (payload: any) => payload,
      (payload, resolve = noop, reject = noop) => ({ resolve, reject }),
    ],
  },

  'PERSONAL_SUBMIT_MESSAGE_WITH_ENTER_SUCCEEDED',
  'PERSONAL_SUBMIT_MESSAGE_WITH_ENTER_FAILED',

  'PERSONAL_LEFT_MENU_SUCCEEDED',
  'PERSONAL_LEFT_MENU_FAILED',

  'PERSONAL_LEFT_MENU_SUCCEEDED',
  'PERSONAL_LEFT_MENU_FAILED',

  'PERSONAL_BUSYLIGHT_SUCCEEDED',
  'PERSONAL_BUSYLIGHT_FAILED',

  'PERSONAL_KEYBOARD_SHORTCUTS_SUCCEEDED',
  'PERSONAL_KEYBOARD_SHORTCUTS_FAILED',

  'PERSONAL_SOUND_SUCCEEDED',
  'PERSONAL_SOUND_FAILED',

  'PERSONAL_LAST_FROM_EMAIL_INTEGRATION_SUCCEEDED',
  'PERSONAL_LAST_FROM_EMAIL_INTEGRATION_FAILED',

  'PERSONAL_CONVERSATION_CARDS_SUCCEEDED',
  'PERSONAL_CONVERSATION_CARDS_FAILED',

  'PERSONAL_REPLY_AREA_HEIGHT_SUCCEEDED',
  'PERSONAL_REPLY_AREA_HEIGHT_FAILED',

  'PERSONAL_ADD_TO_FAVOURITE_QUEUE_IDS_SUCCEEDED',
  'PERSONAL_ADD_TO_FAVOURITE_QUEUE_IDS_FAILED',

  'PERSONAL_REMOVE_FROM_FAVOURITE_QUEUE_IDS_SUCCEEDED',
  'PERSONAL_REMOVE_FROM_FAVOURITE_QUEUE_IDS_FAILED',

  'PERSONAL_ADD_TO_FAVOURITE_TEAM_MEMBER_IDS_SUCCEEDED',
  'PERSONAL_ADD_TO_FAVOURITE_TEAM_MEMBER_IDS_FAILED',

  'PERSONAL_REMOVE_FROM_FAVOURITE_TEAM_MEMBER_IDS_SUCCEEDED',
  'PERSONAL_REMOVE_FROM_FAVOURITE_TEAM_MEMBER_IDS_FAILED',

  'PERSONAL_TOGGLE_STRICT_SEARCH_SUCCEEDED',
  'PERSONAL_TOGGLE_STRICT_SEARCH_FAILED',

  'PERSONAL_TOGGLE_REMEMBER_MICROPHONE_ACCESS_SUCCEEDED',
  'PERSONAL_TOGGLE_REMEMBER_MICROPHONE_ACCESS_FAILED',

  'PERSONAL_CUSTOM_CARD_MENU_SUCCEEDED',
  'PERSONAL_CUSTOM_CARD_MENU_FAILED',

  'PERSONAL_TOGGLE_REMEMBER_ELEVIO_CARD_OPEN_SUCCEEDED',
  'PERSONAL_TOGGLE_REMEMBER_ELEVIO_CARD_OPEN_FAILED',

  'PERSONAL_CHANGED_ELEVIO_SELECTED_LANGUAGE_SUCCEEDED',
  'PERSONAL_CHANGED_ELEVIO_SELECTED_LANGUAGE_FAILED',

  'PERSONAL_TOGGLE_REMEMBER_KNOWLEDGE_CARD_OPEN_SUCCEEDED',
  'PERSONAL_TOGGLE_REMEMBER_KNOWLEDGE_CARD_OPEN_FAILED',
);
